var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"320px","height":"240px","background":"salmon"}},[_c('video-track',{attrs:{"track":_vm.participant.tracks.screenVideo.track}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }